module.exports = __webpack_public_path__ + "static/img/20200518-6.1bcffaf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-6.png
// module id = uRRi
// module chunks = 1